<template>
  <FileSelectList
    ref="listRef"
    v-model="form.files"
    :buildingId="building.id"
    :excludeIds="linkedFileIds"
    :query="query"
  />
</template>

<script setup>
import axios from "axios";
import route from "ziggy-js";
import { computed, ref } from "vue";
import { useForm } from "@inertiajs/vue3";
import { FileSelectList } from "@/SharedComponents/Passport/Steps/Files/Partials";
import { toast } from "@/SharedComponents/Toaster";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["back", "update:item"]);

const listRef = ref(null);

const props = defineProps({
  item: { type: Object, required: true },
  building: { type: Object, required: true },
  query: { type: String, required: false },
});

const linkedFileIds = computed(() => props.item.files.map((f) => f.id));

const form = useForm({
  files: [],
});

function clear() {
  form.reset();
}

function cancel() {
  clear();
  emit("back");
}

const busy = ref(false);

const { t } = useI18n();

function submit() {
  if (busy.value) return;

  busy.value = true;
  axios
    .patch(route("api.files.link"), {
      note_ids: form.files.map((f) => f.id),
      space_ids: [props.item.id],
    })
    .then((res) => {
      toast.success(t("toasts.files.link.success"));
      emit("update:item", {
        item: {
          ...props.item,
          files: [...props.item.files, ...res.data.files],
          expired_files_count:
            props.item.expired_files_count + res.data.expired_count,
        },
        callback: () => {
          cancel();
        },
      });
    })
    .catch((err) => {
      if (err.response.status == 403) {
        toast.error(t("toasts.files.link.403"));
      } else {
        toast.error(err.response.data.message || t("toasts.files.link.error"));
      }
    })
    .finally(() => {
      busy.value = false;
    });
}

defineExpose({
  empty: computed(() => !props.query && listRef.value?.empty),
  isDirty: computed(() => form.isDirty),
  clear,
  cancel,
  submit,
});
</script>
